import React, { useContext, useEffect, useMemo, ReactNode } from 'react';
import { AuthContext } from "context/auth/AuthContext";
import { nodeContextBridge } from "helpers/nodeContextBridge";
import { useSnackbar, SnackbarProvider } from 'notistack';


interface NodeContextValuesExtractorProps {
    children: ReactNode;
}

export const NodeContextValuesExtractor = ({ children }: NodeContextValuesExtractorProps) => {
    const auth = useContext(AuthContext);
    const snackbar = useSnackbar();

    const contextValues = useMemo(() => ({
        values: {
            auth,
            snackbar
        },
        createProviders: (component: ReactNode) => (
            <SnackbarProvider maxSnack={3} domRoot={document.body}>
                <AuthContext.Provider value={auth}>
                    {component}
                </AuthContext.Provider>
            </SnackbarProvider>
        )
    }), [auth, snackbar]);

    nodeContextBridge.setContexts(contextValues);

    useEffect(() => {
        nodeContextBridge.setContexts(contextValues);
    }, [contextValues]);

    return <>{children}</>;
};